import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Waypoint from 'react-waypoint';
import 'url-search-params-polyfill';

import Img from '../../Img';
import Description from '../../text/Description';

import styles from './collegeSearch.scss';
import { getApiAxiosInstance } from '../../../utils/network';

class CollegeSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            showDropDown: false,
            options: [],
            query: props.query || '',
            skip: 0,
            isEnd: false,
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.fetchSearchResults = this.fetchSearchResults.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.loadMoreItems = this.loadMoreItems.bind(this);
        this.handleSearchBackClick = this.handleSearchBackClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.showDropDown) {
            this.setState({
                showDropDown: false,
            });
        }
    }

    handleOnFocus() {
        if (this.state.query.length > 0) {
            this.setState({
                showDropDown: true,
            });
        }
    }

    handleKeyUp(event) {
        console.log('query', event.target.value);
        const query = event.target.value;

        if (query.length > 0) {
            this.setState({
                isLoading: true,
                showDropDown: true,
                query,
                options: [],
                skip: 0,
                isEnd: false,
            }, () => {
                this.fetchSearchResults();
            });
        } else {
            this.setState({
                query: '',
                options: [],
                skip: 0,
                showDropDown: false,
                isEnd: false,
            });
        }
        this.props.handleInputChange(query);
    }

    handlePaste(event) {
        const { target } = event;

        setTimeout(() => {
            const query = target.value.trim();
            if (query.length > 0) {
                this.setState({
                    isLoading: true,
                    showDropDown: true,
                    query,
                    options: [],
                    skip: 0,
                    isEnd: false,
                }, () => {
                    this.fetchSearchResults();
                });
            } else {
                this.setState({
                    query: '',
                    options: [],
                    showDropDown: false,
                    isEnd: false,
                });
            }
        }, 200);
    }

    fetchSearchResults() {
        console.log('fetchSearchResults', this.state.query, this.state.skip, this.state.options.length);
        const axiosInstance = getApiAxiosInstance();
        const { query, skip } = this.state;
        const params = new URLSearchParams();
        params.append('query', query);
        params.append('top', 10);
        params.append('skip', skip);
        if (this.props.searchMembersOnly) {
            params.append('exists', 'memberId');
        }

        const that = this;
        const { CancelToken } = axios;

        if (query.length > 0) {
            if (that.cancel !== undefined) {
                that.cancel();
            }
            axiosInstance.get('v2/search/colleges', {
                cancelToken: new CancelToken(((c) => {
                    that.cancel = c;
                })),
                params,
            }).then((response) => {
                const { hits } = response.data;
                that.setState({
                    options: (skip ? [...that.state.options, ...hits] : hits),
                    isLoading: false,
                    isEnd: hits.length < 10,
                    skip: skip + 10,
                    searched: true,
                });
            }).catch((error) => {
                console.log(error);
                that.setState({
                    isLoading: false,
                    searched: true,
                });
            });
        } else {
            this.setState({
                isLoading: false,
                showDropDown: false,
                options: [],
                query: '',
                skip: 0,
                isEnd: false,
            });
        }
    }

    loadMoreItems() {
        console.log('loadMoreItems', this.state.skip);
        const { isEnd } = this.state;
        if (!this.state.isLoading && !isEnd) {
            this.setState({
                isLoading: true,
            }, () => {
                this.fetchSearchResults();
            });
        }
    }

    handleLinkClick(college) {
        if (this.props.clearAfterSelect) {
            this.setState({
                query: '',
                showDropDown: false,
            });
        }
        if (this.props.populateQueryOnSelect) {
            this.setState({
                query: college.displayName,
                showDropDown: false,
            });
        }
        this.props.handleCollegeSelect(college);
    }

    handleSearchBackClick() {
        this.setState({
            isLoading: false,
            showDropDown: false,
            options: [],
            query: '',
            skip: 0,
            isEnd: false,
        });
    }

    // prevent the fixed positioned div from scrolling the body
    preventDefault(e) {
        e.preventDefault();
    }

    render() {
        const renderCollege = (college, i) => {
            const { displayName, type, location } = college;
            const descriptionItems = [
                ...(type ? [type] : []),
                ...(location && location.display ? [location.display] : []),
            ];
            return (
                <div className={`row ${styles.globalSearchDropdownOption}`} onClick={() => this.handleLinkClick(college)} key={`c${i}`}>
                    <div className="col-2">
                        <Img
                            className={styles.globalSearchDropdownOptionImage}
                            src="/img/v2/icons/icon-avatar-college.svg"
                        />
                    </div>
                    <div className="col-10">
                        <div className={`${styles.name} show-ellipsis`} dangerouslySetInnerHTML={{ __html: displayName }} />
                        <div className={`${styles.place} show-ellipsis`}>
                            <Description desc={descriptionItems} />
                        </div>
                    </div>
                </div>
            );
        };

        const renderDropdown = () => {
            return (
                <div className="pb24">
                    {(this.state.options.length > 0 || this.state.isLoading) && (
                        <div className={styles.globalSearchDropdownOptions}>
                            {this.state.options.map((college, i) => renderCollege(college.source, i))}
                            {this.state.isLoading && (
                                <div className={styles.loading}><i className="fas fa-circle-notch fa-spin" />Loading...</div>
                            )}
                            {!this.state.isLoading && (
                                <Waypoint
                                    onEnter={this.loadMoreItems}
                                    threshold={2.0}
                                />
                            )}

                        </div>
                    )}
                </div>
            );
        };

        return (
            <div className={`${styles.globalSearchContainer} ${styles.lookup}`} ref={this.setWrapperRef}>
                <div className={`${styles.globalSearchInputContainer} ${this.state.showDropDown ? styles.showOnTop : ''}`}>
                    {this.state.showDropDown && (
                        <span
                            className={`d-block d-lg-none fas fa-chevron-left ${styles.feedbackLeft}`}
                            onClick={this.handleSearchBackClick}
                        />
                    )}
                    <input
                        type="text"
                        value={this.state.query}
                        className={`${styles.globalSearchInput} ${this.props.className} ${this.state.showDropDown ? 'dropdown-open' : ''}`}
                        onChange={this.handleKeyUp}
                        onPaste={this.handlePaste}
                        onFocus={this.handleOnFocus}
                        placeholder={this.props.placeholder ? this.props.placeholder : 'Search by name'}
                    />

                </div>
                {this.state.showDropDown && (
                    <div className={`${styles.globalSearchDropdownContainer}`}>
                        {renderDropdown()}
                    </div>
                )}
            </div>
        );
    }
}

const mapDispatchToProps = {};

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollegeSearch);
